// extracted by mini-css-extract-plugin
module.exports = {"label_arrow_box":"LabelArrow_label_arrow_box__3Qw9r"};